import { memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";
import { ArtificialPostcodeList } from "./ArtificialPostcodeList";
import { ArtificialPostcodeViews } from "./ArtificialPostcodeViews";
import { View } from "../Base";
import useWindowDimensions from "../../utils/useWindowDimensions";
import { setAddArtificialPostcodeModalOpen } from "../../reducers/ownApp/";
import { listArtificialTablesSelector } from "../../reducers/depot/selectors";
import { ActionButton } from "../Subheaders/Common/ActionButton";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  list: {
    overflow: "auto",
    marginRight: "-14px",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  buttonContainer: {
    height: "30px",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
});

export const ArtificialPostcodeDetail = memo(({ level }) => {
  const styles = useStyles();
  const dispatch = useDispatch();
  const artificialTables = useSelector(listArtificialTablesSelector);
  const { height: windowHeight } = useWindowDimensions();

  return (
    <div className={styles.container}>
      <ArtificialPostcodeViews />
      <View className={styles.list}>
        <ArtificialPostcodeList
          postcodes={artificialTables[level]}
          height={windowHeight - 256}
        />
      </View>
      <View className={styles.buttonContainer}>
        <ActionButton
          variant={"yellow"}
          disabled={false}
          onClick={() => {
            dispatch(setAddArtificialPostcodeModalOpen(true));
          }}
        >
          + Add New Postcode
        </ActionButton>
      </View>
    </div>
  );
});
